<template>
  <div class="login-container">
    <div class="logo-placeholder">
      <img src="/logo.png" alt="Лого" class="logo" />
    </div>

    <div class="login-card">
      <div class="login-header">
        <h1>Админ</h1>
      </div>
      
      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <label class="form-label">Имейл</label>
          <input
            type="email"
            v-model="email"
            class="form-control"
            placeholder="Въведете вашия имейл"
            required
          />
        </div>
        
        <div class="form-group">
          <label class="form-label">Парола</label>
          <input
            type="password"
            v-model="password"
            class="form-control"
            placeholder="Въведете вашата парола"
            required
          />
        </div>
        
        <button type="submit" class="btn btn-primary login-btn" :disabled="loading">
          <i class="fas fa-sign-in-alt"></i>
          {{ loading ? 'Влизане...' : 'Вход' }}
        </button>
        
        <div v-if="error" class="error">
          {{ getErrorMessage(error) }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { signInWithEmailAndPassword, signOut } from 'firebase/auth'
import { auth, database } from '../firebase'
import { ref as dbRef, get } from 'firebase/database'

export default {
  name: 'LoginPage',
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: ''
    }
  },
  mounted() {
    // Check if there's an access denied error from route query
    if (this.$route.query.error === 'access_denied') {
      this.error = 'Нямате права за достъп до административния панел. Свържете се с администратор.'
    }
  },
  watch: {
    // Watch for route changes to handle error parameter
    '$route.query.error'(newError) {
      if (newError === 'access_denied') {
        this.error = 'Нямате права за достъп до административния панел. Свържете се с администратор.'
      }
    }
  },
  methods: {
    async getUserRole(email) {
      try {
        const userSnapshot = await get(dbRef(database, 'users'))
        const users = userSnapshot.val() || {}
        
        // Find user by email
        const userEntry = Object.entries(users).find(([, user]) => user.email === email)
        if (userEntry) {
          const userData = userEntry[1]
          return userData.role || 0 // Default to 0 if no role specified
        }
        return 0
      } catch (error) {
        console.error('Error getting user role:', error)
        return 0
      }
    },
    async login() {
      if (!this.email || !this.password) {
        this.error = 'Моля, попълнете всички полета'
        return
      }

      this.loading = true
      this.error = ''

      try {
        const userCredential = await signInWithEmailAndPassword(auth, this.email, this.password)
        
        // Check user role after successful authentication
        const userRole = await this.getUserRole(userCredential.user.email)
        
        if (userRole !== 1) {
          // Sign out the user immediately if not admin
          await signOut(auth)
          this.error = 'Нямате права за достъп до административния панел. Свържете се с администратор.'
          return
        }
        
        // Only redirect if user is admin
        this.$router.push('/dashboard')
      } catch (err) {
        this.error = 'Невалиден имейл или парола'
        console.error('Login error:', err)
      } finally {
        this.loading = false
      }
    },
    getErrorMessage(errorMsg) {
      return errorMsg
    }
  }
}
</script>

<style scoped>
.form-group {
  margin-bottom: 0;
}

.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: linear-gradient(135deg, #1D687B 0%, #79daf2 100%);
  padding: 20px;
}

.login-card {
  background: white;
  border-radius: 8px;
  padding: 40px 60px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 400px;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo-placeholder {
  margin-bottom: 24px;
}

.logo {
  width: 160px;
  height: 160px;
  object-fit: contain;
  border-radius: 12px;
  padding: 12px;
}

.login-header h1 {
  color: #333333;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
}

.login-header p {
  color: #666666;
  font-size: 16px;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.login-btn {
  width: 100%;
  padding: 14px;
  font-size: 16px;
  font-weight: 600;
  justify-content: center;
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>
